import React, { PureComponent } from 'react'
import { string, bool, func } from 'prop-types'
import { Icon, Text } from 'components'

import './SelectorButton.css'

const ICON_SWAP_ANIM_DURATION = 300

export class SelectorButton extends PureComponent {
    static propTypes = {
        id: string.isRequired,
        icon: string.isRequired,
        label: string.isRequired,
        selected: bool,
        initial: bool,
        className: string,
        onClick: func
    }
    static defaultProps = {
        selected: false,
        initial: false
    }

    state = {
        icon: null,
        animStatus: '',
    }

    componentWillMount() {
        this.setState({ icon: this.props.icon })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.icon !== this.props.icon) {
            this.startAnimOldIcon()
        }
    }
    componentWillUnmount() {
        this.clearTimeout()
    }

    clearTimeout = () => {
        this.animTimeout && clearTimeout(this.animTimeout)
        this.animTimeout = undefined
    }

    handleOnClick = () => {
        const { id, onClick } = this.props
        onClick && onClick(id)
    }

    startAnimOldIcon = () => {
        if (!this.animTimeout) {
            this.setState({ animStatus: 'Disappearing' })
            this.animTimeout = setTimeout(this.animReplaceIcon, ICON_SWAP_ANIM_DURATION)
        }
    }
    animReplaceIcon = () => {
        this.setState({ icon: this.props.icon, animStatus: 'Appearing' })
        this.clearTimeout()
    }

    render() {
        const { icon: iconFromProps, label, selected, initial, className, onClick, ...otherProps } = this.props
        const { icon, animStatus } = this.state
        return (
            <div
                className={['SelectorButton flex col-center', { Selected: selected, Initial: initial }, animStatus, className]}
                onClick={this.handleOnClick} {...otherProps}
            >
                <div className="flex col-center shadow-hover">
                    <div className="icon-wrapper">
                        <Icon name={icon} />
                    </div>
                </div>
                <Text dangerouslySetInnerHTML={{ __html: label }} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Buttons/SelectorButton/SelectorButton.js